import { Link } from 'react-router';

import { ROUTES } from '@/shared/config';
import { DrawsPromo } from '@/widgets/draws-promo';

import styles from './DrawsPage.module.scss';

export function DrawsPage() {
  return (
    <div className={styles.page}>
      <div className={styles.titleRow}>
        <Link className={styles.back} to={ROUTES.home} aria-label="Назад">
          <img src="/images/matches/back.svg" alt="" aria-hidden className={styles.backIcon} />
        </Link>
        <h1 className={styles.title}>Розыгрыши</h1>
      </div>

      <DrawsPromo />
    </div>
  );
}
